interface WalletPendingStateInput {
  pendingPayoutCents?: number | null;
  affiliatePendingCents?: number | null;
  pendingKind?: string | null;
}

function nonNegativeCents(value: number | null | undefined): number {
  return Number.isFinite(value) ? Math.max(0, value ?? 0) : 0;
}

export function deriveWalletPendingState({
  pendingPayoutCents,
  affiliatePendingCents,
  pendingKind,
}: WalletPendingStateInput) {
  const payoutCents = nonNegativeCents(pendingPayoutCents);
  const affiliateCents = nonNegativeCents(affiliatePendingCents);
  const hasPendingPayout = payoutCents > 0 && !!pendingKind;

  return {
    pendingPayoutCents: payoutCents,
    affiliatePendingCents: affiliateCents,
    hasPendingPayout,
    hasAffiliateHold: affiliateCents > 0,
    isRedemptionHold: hasPendingPayout
      && (pendingKind === "plan_redemption" || pendingKind === "minutes_redemption"),
  };
}
